"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createConsoleLogger = void 0;
const _1 = require(".");
/**
 * Creates a logger that logs to the console.
 */
const createConsoleLogger = () => (0, _1.createCoreLogger)((level, event) => console[level](JSON.stringify({
    eventType: level.toUpperCase(),
    ...event,
})));
exports.createConsoleLogger = createConsoleLogger;
